/**
 * @fileoverview gRPC-Web generated client stub for datalake
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.1
// source: datalake.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as datalake_pb from './datalake_pb'; // proto import: "datalake.proto"
import * as google_protobuf_empty_pb from 'google-protobuf/google/protobuf/empty_pb'; // proto import: "google/protobuf/empty.proto"


export class DataLakeServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorHealthCheck = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/HealthCheck',
    grpcWeb.MethodType.UNARY,
    google_protobuf_empty_pb.Empty,
    datalake_pb.HealthCheckResponse,
    (request: google_protobuf_empty_pb.Empty) => {
      return request.serializeBinary();
    },
    datalake_pb.HealthCheckResponse.deserializeBinary
  );

  healthCheck(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.HealthCheckResponse>;

  healthCheck(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.HealthCheckResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.HealthCheckResponse>;

  healthCheck(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.HealthCheckResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/HealthCheck',
        request,
        metadata || {},
        this.methodDescriptorHealthCheck,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/HealthCheck',
    request,
    metadata || {},
    this.methodDescriptorHealthCheck);
  }

  methodDescriptorSelectImages = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/SelectImages',
    grpcWeb.MethodType.UNARY,
    datalake_pb.SelectImagesRequest,
    datalake_pb.SelectImagesResponse,
    (request: datalake_pb.SelectImagesRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.SelectImagesResponse.deserializeBinary
  );

  selectImages(
    request: datalake_pb.SelectImagesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.SelectImagesResponse>;

  selectImages(
    request: datalake_pb.SelectImagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.SelectImagesResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.SelectImagesResponse>;

  selectImages(
    request: datalake_pb.SelectImagesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.SelectImagesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/SelectImages',
        request,
        metadata || {},
        this.methodDescriptorSelectImages,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/SelectImages',
    request,
    metadata || {},
    this.methodDescriptorSelectImages);
  }

  methodDescriptorQueryImages = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/QueryImages',
    grpcWeb.MethodType.UNARY,
    datalake_pb.QueryImagesRequest,
    datalake_pb.QueryImagesResponse,
    (request: datalake_pb.QueryImagesRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.QueryImagesResponse.deserializeBinary
  );

  queryImages(
    request: datalake_pb.QueryImagesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.QueryImagesResponse>;

  queryImages(
    request: datalake_pb.QueryImagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.QueryImagesResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.QueryImagesResponse>;

  queryImages(
    request: datalake_pb.QueryImagesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.QueryImagesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/QueryImages',
        request,
        metadata || {},
        this.methodDescriptorQueryImages,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/QueryImages',
    request,
    metadata || {},
    this.methodDescriptorQueryImages);
  }

  methodDescriptorGetQueryableAttributes = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetQueryableAttributes',
    grpcWeb.MethodType.UNARY,
    google_protobuf_empty_pb.Empty,
    datalake_pb.QueryableAttributesResponse,
    (request: google_protobuf_empty_pb.Empty) => {
      return request.serializeBinary();
    },
    datalake_pb.QueryableAttributesResponse.deserializeBinary
  );

  getQueryableAttributes(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.QueryableAttributesResponse>;

  getQueryableAttributes(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.QueryableAttributesResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.QueryableAttributesResponse>;

  getQueryableAttributes(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.QueryableAttributesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetQueryableAttributes',
        request,
        metadata || {},
        this.methodDescriptorGetQueryableAttributes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetQueryableAttributes',
    request,
    metadata || {},
    this.methodDescriptorGetQueryableAttributes);
  }

  methodDescriptorRegisterAnnotationBatch = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/RegisterAnnotationBatch',
    grpcWeb.MethodType.UNARY,
    datalake_pb.RegisterAnnotationBatchRequest,
    datalake_pb.RegisterAnnotationBatchResponse,
    (request: datalake_pb.RegisterAnnotationBatchRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.RegisterAnnotationBatchResponse.deserializeBinary
  );

  registerAnnotationBatch(
    request: datalake_pb.RegisterAnnotationBatchRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.RegisterAnnotationBatchResponse>;

  registerAnnotationBatch(
    request: datalake_pb.RegisterAnnotationBatchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.RegisterAnnotationBatchResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.RegisterAnnotationBatchResponse>;

  registerAnnotationBatch(
    request: datalake_pb.RegisterAnnotationBatchRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.RegisterAnnotationBatchResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/RegisterAnnotationBatch',
        request,
        metadata || {},
        this.methodDescriptorRegisterAnnotationBatch,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/RegisterAnnotationBatch',
    request,
    metadata || {},
    this.methodDescriptorRegisterAnnotationBatch);
  }

  methodDescriptorPullGroup = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/PullGroup',
    grpcWeb.MethodType.UNARY,
    datalake_pb.PullGroupRequest,
    datalake_pb.PullGroupResponse,
    (request: datalake_pb.PullGroupRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.PullGroupResponse.deserializeBinary
  );

  pullGroup(
    request: datalake_pb.PullGroupRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.PullGroupResponse>;

  pullGroup(
    request: datalake_pb.PullGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.PullGroupResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.PullGroupResponse>;

  pullGroup(
    request: datalake_pb.PullGroupRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.PullGroupResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/PullGroup',
        request,
        metadata || {},
        this.methodDescriptorPullGroup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/PullGroup',
    request,
    metadata || {},
    this.methodDescriptorPullGroup);
  }

  methodDescriptorGetAllGroups = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetAllGroups',
    grpcWeb.MethodType.UNARY,
    google_protobuf_empty_pb.Empty,
    datalake_pb.GetAllGroupsResponse,
    (request: google_protobuf_empty_pb.Empty) => {
      return request.serializeBinary();
    },
    datalake_pb.GetAllGroupsResponse.deserializeBinary
  );

  getAllGroups(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.GetAllGroupsResponse>;

  getAllGroups(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.GetAllGroupsResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.GetAllGroupsResponse>;

  getAllGroups(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.GetAllGroupsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetAllGroups',
        request,
        metadata || {},
        this.methodDescriptorGetAllGroups,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetAllGroups',
    request,
    metadata || {},
    this.methodDescriptorGetAllGroups);
  }

  methodDescriptorGetCropGroups = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetCropGroups',
    grpcWeb.MethodType.UNARY,
    datalake_pb.GetCropGroupsRequest,
    datalake_pb.GetCropGroupsResponse,
    (request: datalake_pb.GetCropGroupsRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.GetCropGroupsResponse.deserializeBinary
  );

  getCropGroups(
    request: datalake_pb.GetCropGroupsRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.GetCropGroupsResponse>;

  getCropGroups(
    request: datalake_pb.GetCropGroupsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.GetCropGroupsResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.GetCropGroupsResponse>;

  getCropGroups(
    request: datalake_pb.GetCropGroupsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.GetCropGroupsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetCropGroups',
        request,
        metadata || {},
        this.methodDescriptorGetCropGroups,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetCropGroups',
    request,
    metadata || {},
    this.methodDescriptorGetCropGroups);
  }

  methodDescriptorAddAnnotationsToBatch = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/AddAnnotationsToBatch',
    grpcWeb.MethodType.UNARY,
    datalake_pb.AddAnnotationsToBatchRequest,
    datalake_pb.AddAnnotationsToBatchResponse,
    (request: datalake_pb.AddAnnotationsToBatchRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.AddAnnotationsToBatchResponse.deserializeBinary
  );

  addAnnotationsToBatch(
    request: datalake_pb.AddAnnotationsToBatchRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.AddAnnotationsToBatchResponse>;

  addAnnotationsToBatch(
    request: datalake_pb.AddAnnotationsToBatchRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.AddAnnotationsToBatchResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.AddAnnotationsToBatchResponse>;

  addAnnotationsToBatch(
    request: datalake_pb.AddAnnotationsToBatchRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.AddAnnotationsToBatchResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/AddAnnotationsToBatch',
        request,
        metadata || {},
        this.methodDescriptorAddAnnotationsToBatch,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/AddAnnotationsToBatch',
    request,
    metadata || {},
    this.methodDescriptorAddAnnotationsToBatch);
  }

  methodDescriptorGetGroupHistory = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetGroupHistory',
    grpcWeb.MethodType.UNARY,
    datalake_pb.GroupHistoryRequest,
    datalake_pb.GroupHistoryResponse,
    (request: datalake_pb.GroupHistoryRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.GroupHistoryResponse.deserializeBinary
  );

  getGroupHistory(
    request: datalake_pb.GroupHistoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.GroupHistoryResponse>;

  getGroupHistory(
    request: datalake_pb.GroupHistoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.GroupHistoryResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.GroupHistoryResponse>;

  getGroupHistory(
    request: datalake_pb.GroupHistoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.GroupHistoryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetGroupHistory',
        request,
        metadata || {},
        this.methodDescriptorGetGroupHistory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetGroupHistory',
    request,
    metadata || {},
    this.methodDescriptorGetGroupHistory);
  }

  methodDescriptorQueryInGroup = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/QueryInGroup',
    grpcWeb.MethodType.UNARY,
    datalake_pb.QueryInGroupRequest,
    datalake_pb.QueryInGroupResponse,
    (request: datalake_pb.QueryInGroupRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.QueryInGroupResponse.deserializeBinary
  );

  queryInGroup(
    request: datalake_pb.QueryInGroupRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.QueryInGroupResponse>;

  queryInGroup(
    request: datalake_pb.QueryInGroupRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.QueryInGroupResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.QueryInGroupResponse>;

  queryInGroup(
    request: datalake_pb.QueryInGroupRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.QueryInGroupResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/QueryInGroup',
        request,
        metadata || {},
        this.methodDescriptorQueryInGroup,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/QueryInGroup',
    request,
    metadata || {},
    this.methodDescriptorQueryInGroup);
  }

  methodDescriptorGetGroupMetadata = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetGroupMetadata',
    grpcWeb.MethodType.UNARY,
    datalake_pb.GetGroupMetadataRequest,
    datalake_pb.GetGroupMetadataResponse,
    (request: datalake_pb.GetGroupMetadataRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.GetGroupMetadataResponse.deserializeBinary
  );

  getGroupMetadata(
    request: datalake_pb.GetGroupMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.GetGroupMetadataResponse>;

  getGroupMetadata(
    request: datalake_pb.GetGroupMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.GetGroupMetadataResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.GetGroupMetadataResponse>;

  getGroupMetadata(
    request: datalake_pb.GetGroupMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.GetGroupMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetGroupMetadata',
        request,
        metadata || {},
        this.methodDescriptorGetGroupMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetGroupMetadata',
    request,
    metadata || {},
    this.methodDescriptorGetGroupMetadata);
  }

  methodDescriptorGetImageGSD = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetImageGSD',
    grpcWeb.MethodType.UNARY,
    datalake_pb.GetImageGSDRequest,
    datalake_pb.GetImageGSDResponse,
    (request: datalake_pb.GetImageGSDRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.GetImageGSDResponse.deserializeBinary
  );

  getImageGSD(
    request: datalake_pb.GetImageGSDRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.GetImageGSDResponse>;

  getImageGSD(
    request: datalake_pb.GetImageGSDRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.GetImageGSDResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.GetImageGSDResponse>;

  getImageGSD(
    request: datalake_pb.GetImageGSDRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.GetImageGSDResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetImageGSD',
        request,
        metadata || {},
        this.methodDescriptorGetImageGSD,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetImageGSD',
    request,
    metadata || {},
    this.methodDescriptorGetImageGSD);
  }

  methodDescriptorGetImageMetadata = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetImageMetadata',
    grpcWeb.MethodType.UNARY,
    datalake_pb.GetImageMetadataRequest,
    datalake_pb.GetImageMetadataResponse,
    (request: datalake_pb.GetImageMetadataRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.GetImageMetadataResponse.deserializeBinary
  );

  getImageMetadata(
    request: datalake_pb.GetImageMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.GetImageMetadataResponse>;

  getImageMetadata(
    request: datalake_pb.GetImageMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.GetImageMetadataResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.GetImageMetadataResponse>;

  getImageMetadata(
    request: datalake_pb.GetImageMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.GetImageMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetImageMetadata',
        request,
        metadata || {},
        this.methodDescriptorGetImageMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetImageMetadata',
    request,
    metadata || {},
    this.methodDescriptorGetImageMetadata);
  }

  methodDescriptorGetCollectionMetadata = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetCollectionMetadata',
    grpcWeb.MethodType.UNARY,
    datalake_pb.GetCollectionMetadataRequest,
    datalake_pb.GetCollectionMetadataResponse,
    (request: datalake_pb.GetCollectionMetadataRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.GetCollectionMetadataResponse.deserializeBinary
  );

  getCollectionMetadata(
    request: datalake_pb.GetCollectionMetadataRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.GetCollectionMetadataResponse>;

  getCollectionMetadata(
    request: datalake_pb.GetCollectionMetadataRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.GetCollectionMetadataResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.GetCollectionMetadataResponse>;

  getCollectionMetadata(
    request: datalake_pb.GetCollectionMetadataRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.GetCollectionMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetCollectionMetadata',
        request,
        metadata || {},
        this.methodDescriptorGetCollectionMetadata,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetCollectionMetadata',
    request,
    metadata || {},
    this.methodDescriptorGetCollectionMetadata);
  }

  methodDescriptorGetCollectionMetadataFromText = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetCollectionMetadataFromText',
    grpcWeb.MethodType.UNARY,
    datalake_pb.GetCollectionMetadataTextRequest,
    datalake_pb.GetCollectionMetadataResponse,
    (request: datalake_pb.GetCollectionMetadataTextRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.GetCollectionMetadataResponse.deserializeBinary
  );

  getCollectionMetadataFromText(
    request: datalake_pb.GetCollectionMetadataTextRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.GetCollectionMetadataResponse>;

  getCollectionMetadataFromText(
    request: datalake_pb.GetCollectionMetadataTextRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.GetCollectionMetadataResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.GetCollectionMetadataResponse>;

  getCollectionMetadataFromText(
    request: datalake_pb.GetCollectionMetadataTextRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.GetCollectionMetadataResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetCollectionMetadataFromText',
        request,
        metadata || {},
        this.methodDescriptorGetCollectionMetadataFromText,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetCollectionMetadataFromText',
    request,
    metadata || {},
    this.methodDescriptorGetCollectionMetadataFromText);
  }

  methodDescriptorUpdateImages = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/UpdateImages',
    grpcWeb.MethodType.UNARY,
    datalake_pb.UpdateImagesRequest,
    datalake_pb.UpdateImagesResponse,
    (request: datalake_pb.UpdateImagesRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.UpdateImagesResponse.deserializeBinary
  );

  updateImages(
    request: datalake_pb.UpdateImagesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.UpdateImagesResponse>;

  updateImages(
    request: datalake_pb.UpdateImagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.UpdateImagesResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.UpdateImagesResponse>;

  updateImages(
    request: datalake_pb.UpdateImagesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.UpdateImagesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/UpdateImages',
        request,
        metadata || {},
        this.methodDescriptorUpdateImages,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/UpdateImages',
    request,
    metadata || {},
    this.methodDescriptorUpdateImages);
  }

  methodDescriptorDeleteImages = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/DeleteImages',
    grpcWeb.MethodType.UNARY,
    datalake_pb.DeleteImagesRequest,
    datalake_pb.DeleteImagesResponse,
    (request: datalake_pb.DeleteImagesRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.DeleteImagesResponse.deserializeBinary
  );

  deleteImages(
    request: datalake_pb.DeleteImagesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.DeleteImagesResponse>;

  deleteImages(
    request: datalake_pb.DeleteImagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.DeleteImagesResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.DeleteImagesResponse>;

  deleteImages(
    request: datalake_pb.DeleteImagesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.DeleteImagesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/DeleteImages',
        request,
        metadata || {},
        this.methodDescriptorDeleteImages,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/DeleteImages',
    request,
    metadata || {},
    this.methodDescriptorDeleteImages);
  }

  methodDescriptorRegisterImages = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/RegisterImages',
    grpcWeb.MethodType.UNARY,
    datalake_pb.RegisterImagesRequest,
    datalake_pb.RegisterImagesResponse,
    (request: datalake_pb.RegisterImagesRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.RegisterImagesResponse.deserializeBinary
  );

  registerImages(
    request: datalake_pb.RegisterImagesRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.RegisterImagesResponse>;

  registerImages(
    request: datalake_pb.RegisterImagesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.RegisterImagesResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.RegisterImagesResponse>;

  registerImages(
    request: datalake_pb.RegisterImagesRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.RegisterImagesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/RegisterImages',
        request,
        metadata || {},
        this.methodDescriptorRegisterImages,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/RegisterImages',
    request,
    metadata || {},
    this.methodDescriptorRegisterImages);
  }

  methodDescriptorRegisterDataset = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/RegisterDataset',
    grpcWeb.MethodType.UNARY,
    datalake_pb.RegisterDatasetRequest,
    datalake_pb.RegisterDatasetResponse,
    (request: datalake_pb.RegisterDatasetRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.RegisterDatasetResponse.deserializeBinary
  );

  registerDataset(
    request: datalake_pb.RegisterDatasetRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.RegisterDatasetResponse>;

  registerDataset(
    request: datalake_pb.RegisterDatasetRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.RegisterDatasetResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.RegisterDatasetResponse>;

  registerDataset(
    request: datalake_pb.RegisterDatasetRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.RegisterDatasetResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/RegisterDataset',
        request,
        metadata || {},
        this.methodDescriptorRegisterDataset,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/RegisterDataset',
    request,
    metadata || {},
    this.methodDescriptorRegisterDataset);
  }

  methodDescriptorPullDataset = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/PullDataset',
    grpcWeb.MethodType.UNARY,
    datalake_pb.PullDatasetRequest,
    datalake_pb.PullDatasetResponse,
    (request: datalake_pb.PullDatasetRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.PullDatasetResponse.deserializeBinary
  );

  pullDataset(
    request: datalake_pb.PullDatasetRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.PullDatasetResponse>;

  pullDataset(
    request: datalake_pb.PullDatasetRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.PullDatasetResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.PullDatasetResponse>;

  pullDataset(
    request: datalake_pb.PullDatasetRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.PullDatasetResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/PullDataset',
        request,
        metadata || {},
        this.methodDescriptorPullDataset,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/PullDataset',
    request,
    metadata || {},
    this.methodDescriptorPullDataset);
  }

  methodDescriptorAddAugmentationToDataset = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/AddAugmentationToDataset',
    grpcWeb.MethodType.UNARY,
    datalake_pb.AddAugmentationRequest,
    datalake_pb.AddAugmentationResponse,
    (request: datalake_pb.AddAugmentationRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.AddAugmentationResponse.deserializeBinary
  );

  addAugmentationToDataset(
    request: datalake_pb.AddAugmentationRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.AddAugmentationResponse>;

  addAugmentationToDataset(
    request: datalake_pb.AddAugmentationRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.AddAugmentationResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.AddAugmentationResponse>;

  addAugmentationToDataset(
    request: datalake_pb.AddAugmentationRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.AddAugmentationResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/AddAugmentationToDataset',
        request,
        metadata || {},
        this.methodDescriptorAddAugmentationToDataset,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/AddAugmentationToDataset',
    request,
    metadata || {},
    this.methodDescriptorAddAugmentationToDataset);
  }

  methodDescriptorDataCurationPipeline = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/DataCurationPipeline',
    grpcWeb.MethodType.UNARY,
    datalake_pb.DataCurationPipelineRequest,
    datalake_pb.DataCurationPipelineResponse,
    (request: datalake_pb.DataCurationPipelineRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.DataCurationPipelineResponse.deserializeBinary
  );

  dataCurationPipeline(
    request: datalake_pb.DataCurationPipelineRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.DataCurationPipelineResponse>;

  dataCurationPipeline(
    request: datalake_pb.DataCurationPipelineRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.DataCurationPipelineResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.DataCurationPipelineResponse>;

  dataCurationPipeline(
    request: datalake_pb.DataCurationPipelineRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.DataCurationPipelineResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/DataCurationPipeline',
        request,
        metadata || {},
        this.methodDescriptorDataCurationPipeline,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/DataCurationPipeline',
    request,
    metadata || {},
    this.methodDescriptorDataCurationPipeline);
  }

  methodDescriptorDataCurationPipelineStream = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/DataCurationPipelineStream',
    grpcWeb.MethodType.SERVER_STREAMING,
    datalake_pb.DataCurationPipelineRequest,
    datalake_pb.DataCurationPipelineResponse,
    (request: datalake_pb.DataCurationPipelineRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.DataCurationPipelineResponse.deserializeBinary
  );

  dataCurationPipelineStream(
    request: datalake_pb.DataCurationPipelineRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<datalake_pb.DataCurationPipelineResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/datalake.DataLakeService/DataCurationPipelineStream',
      request,
      metadata || {},
      this.methodDescriptorDataCurationPipelineStream);
  }

  methodDescriptorGetPipelineStatus = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetPipelineStatus',
    grpcWeb.MethodType.UNARY,
    datalake_pb.PipelineStatusRequest,
    datalake_pb.PipelineStatusResponse,
    (request: datalake_pb.PipelineStatusRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.PipelineStatusResponse.deserializeBinary
  );

  getPipelineStatus(
    request: datalake_pb.PipelineStatusRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.PipelineStatusResponse>;

  getPipelineStatus(
    request: datalake_pb.PipelineStatusRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.PipelineStatusResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.PipelineStatusResponse>;

  getPipelineStatus(
    request: datalake_pb.PipelineStatusRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.PipelineStatusResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetPipelineStatus',
        request,
        metadata || {},
        this.methodDescriptorGetPipelineStatus,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetPipelineStatus',
    request,
    metadata || {},
    this.methodDescriptorGetPipelineStatus);
  }

  methodDescriptorWatchPipeline = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/WatchPipeline',
    grpcWeb.MethodType.SERVER_STREAMING,
    datalake_pb.WatchPipelineRequest,
    datalake_pb.DataCurationPipelineResponse,
    (request: datalake_pb.WatchPipelineRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.DataCurationPipelineResponse.deserializeBinary
  );

  watchPipeline(
    request: datalake_pb.WatchPipelineRequest,
    metadata?: grpcWeb.Metadata): grpcWeb.ClientReadableStream<datalake_pb.DataCurationPipelineResponse> {
    return this.client_.serverStreaming(
      this.hostname_ +
        '/datalake.DataLakeService/WatchPipeline',
      request,
      metadata || {},
      this.methodDescriptorWatchPipeline);
  }

  methodDescriptorListActivePipelines = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/ListActivePipelines',
    grpcWeb.MethodType.UNARY,
    google_protobuf_empty_pb.Empty,
    datalake_pb.ActivePipelinesResponse,
    (request: google_protobuf_empty_pb.Empty) => {
      return request.serializeBinary();
    },
    datalake_pb.ActivePipelinesResponse.deserializeBinary
  );

  listActivePipelines(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.ActivePipelinesResponse>;

  listActivePipelines(
    request: google_protobuf_empty_pb.Empty,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.ActivePipelinesResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.ActivePipelinesResponse>;

  listActivePipelines(
    request: google_protobuf_empty_pb.Empty,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.ActivePipelinesResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/ListActivePipelines',
        request,
        metadata || {},
        this.methodDescriptorListActivePipelines,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/ListActivePipelines',
    request,
    metadata || {},
    this.methodDescriptorListActivePipelines);
  }

  methodDescriptorGetPipelineHistory = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/GetPipelineHistory',
    grpcWeb.MethodType.UNARY,
    datalake_pb.PipelineHistoryRequest,
    datalake_pb.PipelineHistoryResponse,
    (request: datalake_pb.PipelineHistoryRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.PipelineHistoryResponse.deserializeBinary
  );

  getPipelineHistory(
    request: datalake_pb.PipelineHistoryRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.PipelineHistoryResponse>;

  getPipelineHistory(
    request: datalake_pb.PipelineHistoryRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.PipelineHistoryResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.PipelineHistoryResponse>;

  getPipelineHistory(
    request: datalake_pb.PipelineHistoryRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.PipelineHistoryResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/GetPipelineHistory',
        request,
        metadata || {},
        this.methodDescriptorGetPipelineHistory,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/GetPipelineHistory',
    request,
    metadata || {},
    this.methodDescriptorGetPipelineHistory);
  }

  methodDescriptorCancelPipeline = new grpcWeb.MethodDescriptor(
    '/datalake.DataLakeService/CancelPipeline',
    grpcWeb.MethodType.UNARY,
    datalake_pb.CancelPipelineRequest,
    datalake_pb.CancelPipelineResponse,
    (request: datalake_pb.CancelPipelineRequest) => {
      return request.serializeBinary();
    },
    datalake_pb.CancelPipelineResponse.deserializeBinary
  );

  cancelPipeline(
    request: datalake_pb.CancelPipelineRequest,
    metadata?: grpcWeb.Metadata | null): Promise<datalake_pb.CancelPipelineResponse>;

  cancelPipeline(
    request: datalake_pb.CancelPipelineRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: datalake_pb.CancelPipelineResponse) => void): grpcWeb.ClientReadableStream<datalake_pb.CancelPipelineResponse>;

  cancelPipeline(
    request: datalake_pb.CancelPipelineRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: datalake_pb.CancelPipelineResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/datalake.DataLakeService/CancelPipeline',
        request,
        metadata || {},
        this.methodDescriptorCancelPipeline,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/datalake.DataLakeService/CancelPipeline',
    request,
    metadata || {},
    this.methodDescriptorCancelPipeline);
  }

}

